import { initTimestamps } from '../timestamp';
import { type Timestamp } from './adaptor';

export interface IFirestoreModel extends ISoftDelete {
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export interface ISoftDelete {
  deleted: boolean;
}

export function undeletedFilter<IDocumentData extends ISoftDelete>(
  data: IDocumentData
): boolean {
  return data.deleted !== true;
}

export interface IDeleteAfter {
  deleteAfter: Timestamp;
}

export function initFirestoreModel(): IFirestoreModel {
  return {
    ...initTimestamps(),
    deleted: false,
  };
}

export type FirestoreModelConstructor<T> = { new (): T };
